import React, { Component } from 'react';

export default class MinimumRates extends Component {
  static defaultProps = {
    minimumRates: {},
    promotions: []
  }

  getButlerLevel() {
    if (!('BUTLER' in this.props.minimumRates)) {
      return (<div />);
    }

    return (
      <div className="price-bottom-item">
        <h5>butler level</h5>
        <div className="price-value">
          <span className="lg-4 price-value-3">
            <span className="top-value">ADULTS</span>
            <span className="bottom-value">FROM</span>
          </span>
          <span className="lg-4 price-value-2">${this.props.minimumRates.BUTLER.averageRate}</span>
          <span className="lg-4 price-value-3">
            <span className="top-value">PP/PN</span>
            <span className="bottom-value">(USD)</span>
          </span>
        </div>
        <div className="price-value kids-from">
          <span className="lg-4 price-value-3">
            <span className="top-value">KIDS</span>
            <span className="bottom-value">FROM</span>
          </span>
          <span className="lg-4 price-value-2">${this.props.minimumRates.BUTLER.childRate}</span>
          <span className="lg-4 price-value-3">
            <span className="top-value">PP/PN</span>
            <span className="bottom-value">(USD)</span>
          </span>
        </div>
        <a className="btn-price-view" href={this.props.accomodationsURL}>View Rooms</a>
      </div>
    );
  }

  getClubLevel() {
    if (!('CLUB' in this.props.minimumRates)) {
      return (<div />);
    }

    return (
      <div className="price-bottom-item">
        <h5>concierge level</h5>
        <div className="price-value">
          <span className="lg-4 price-value-3">
            <span className="top-value">ADULTS</span>
            <span className="bottom-value">FROM</span>
          </span>
          <span className="lg-4 price-value-2">${this.props.minimumRates.CLUB.averageRate}</span>
          <span className="lg-4 price-value-3">
            <span className="top-value">PP/PN</span>
            <span className="bottom-value">(USD)</span>
          </span>
        </div>
        <div className="price-value kids-from">
          <span className="lg-4 price-value-3">
            <span className="top-value">KIDS</span>
            <span className="bottom-value">FROM</span>
          </span>
          <span className="lg-4 price-value-2">${this.props.minimumRates.CLUB.childRate}</span>
          <span className="lg-4 price-value-3">
            <span className="top-value">PP/PN</span>
            <span className="bottom-value">(USD)</span>
          </span>
        </div>
        <a className="btn-price-view" href={this.props.accomodationsURL}>View Rooms</a>
      </div>
    );
  }

  getLuxuryLevel() {
    if (!('LUXURY' in this.props.minimumRates)) {
      return (<div />);
    }

    return (
      <div className="price-bottom-item">
        <h5>luxury level</h5>
        <div className="price-value">
          <span className="lg-4 price-value-3">
            <span className="top-value">ADULTS</span>
            <span className="bottom-value">FROM</span>
          </span>
          <span className="lg-4 price-value-2">${this.props.minimumRates.LUXURY.averageRate}</span>
          <span className="lg-4 price-value-3">
            <span className="top-value">PP/PN</span>
            <span className="bottom-value">(USD)</span>
          </span>
        </div>
        <div className="price-value kids-from">
          <span className="lg-4 price-value-3">
            <span className="top-value">KIDS</span>
            <span className="bottom-value">FROM</span>
          </span>
          <span className="lg-4 price-value-2">${this.props.minimumRates.LUXURY.childRate}</span>
          <span className="lg-4 price-value-3">
            <span className="top-value">PP/PN</span>
            <span className="bottom-value">(USD)</span>
          </span>
        </div>
        <a className="btn-price-view" href={this.props.accomodationsURL}>View Rooms</a>
      </div>
    );
  }

  render() {
    return (
      <div className={`price-bottom ${this.props.rstCode === 'BBO' ? 'bbo' : ''} ${this.props.promotions.length >= 5 ? ' five-promotions' : ''}`}>
        {this.getLuxuryLevel()}
        {this.getClubLevel()}
        {this.getButlerLevel()}
      </div>
    );
  }
}
